import { render } from '@/render';
import { Exercises } from '@/pages/Exercises';

render(<Exercises />);
